import https from "./https";
import store from "@/store";

const coupon = {
  async getRedeemCodeBundles(params) {
    const { data } = await https.get(`${store.state.liffGeneral.orgCode}/liff/redeem-code-bundles`, { params })
    return {
      data: data.data,
      lastPage: data.meta.last_page,
      total: data.meta.total,
    }
  },

  async getRedeemCodeBundleCategoryCounts(params) {
    const { data } = await https.get(`${store.state.liffGeneral.orgCode}/liff/redeem-code-bundles/category-counts`, { params })
    return data
  },

  async getRedeemCodeBundle(redeemCouponBundleId) {
    const { data } = await https.get(`${store.state.liffGeneral.orgCode}/liff/redeem-code-bundles/${redeemCouponBundleId}`)
    return data.data
  },

  async applyCouponFromRedeemCodeBundle(redeemCouponBundle, params = {}) {
    const { data } = await https.post(`${store.state.liffGeneral.orgCode}/liff/redeem-code-bundles/${redeemCouponBundle.id}/apply`, params)
    return data
  },

  async getCoupons(params) {
    const { data } = await https.get(`${store.state.liffGeneral.orgCode}/liff/redeem-codes`, { params })
    return data.data
  },

  async applyCoupon(coupon) {
    await https.post(`${store.state.liffGeneral.orgCode}/liff/redeem-codes/${coupon.id}/apply`)
  },

  async takeCoupon(code) {
    const { data } = await https.post(`${store.state.liffGeneral.orgCode}/liff/redeem-codes/take`, { code })
    return data.coupon
  },

  async redeemCoupon(coupon) {
    await https.post(`${store.state.liffGeneral.orgCode}/liff/redeem-codes/${coupon.id}/redeem`, coupon)
  },

  async getCoupon(id) {
    const { data } = await https.get(`${store.state.liffGeneral.orgCode}/liff/redeem-codes/${id}`)
    return data.data
  },

  async myCodesInBundle(bundleId) {
    const { data } = await https.get(`${store.state.liffGeneral.orgCode}/liff/redeem-codes/my-codes-in-bundle/${bundleId}`)
    return data.data
  },

  async getCouponLists(params) {
    const { data } = await https.get(`${store.state.liffGeneral.orgCode}/liff/coupon-list`, { params })
    return {
      data: data.data,
      total: data.meta.total,
      lastPage: data.meta.last_page,
      hasNext: data.meta.has_next,
      provider: data.provider,
    }
  },

  async redeemCouponFromRedeemCodeBundle(redeemCodeBundleId, coupon) {
    const { data } = await https.post(`${store.state.liffGeneral.orgCode}/liff/redeem-code-bundles/${redeemCodeBundleId}/redeem`, coupon)
    return data
  },
}

export default coupon
